import React, { useContext } from 'react';

import { Container } from 'components/common';
import Image from 'components/common/Image';
import { LangContext } from 'providers/LangProvider';
import { Title, Wrapper } from './styles';

export const Hero = () => {
  const { lang } = useContext(LangContext);

  return (
    <Wrapper>
      <Image
        file="hvik_tommi_8.jpg"
        alt={lang === 'is' ? 'Víkin og klettarnir við Hindisvík' : 'The bay and cliffs at Hindisvík'}
        loading="eager"
        fadeIn={false}
        imgStyle={{ objectPosition: '70% center' }}
      />
      <Title as={Container}>
        <h1>Hindisvík</h1>
        <p>{lang === 'is' ? 'Vatnsnesi, Húnaþingi vestra' : 'Vatnsnes, Northwest Iceland'}</p>
      </Title>
    </Wrapper>
  );
};
